let baseUrl = "https://f.youdao.com";
// let baseUrl = "https://at-test1.youdao.com";
// export const baseUrl = "https://at-test1.youdao.com"
console.log(window.location.href)
console.log(window.location.href.includes("at-test1"))
if (window.location.href.includes("at-test1")) {
  baseUrl = "https://at-test1.youdao.com";
} else if (window.location.href.includes("f.youdao")) {
  baseUrl = "https://f.youdao.com";
} else {
  baseUrl = "https://f.youdao.com";
}

export default {
  baseUrl: baseUrl,
};
